/* created by CoolGuy on 2019/2/16 */
import AjaxAction from "../actions/AjaxAction";
import {combineReducers} from "redux";


const total = (state = {}, action)=>{
    switch (action.type) {
        case AjaxAction.CHECK_CURRENT_USER_CLEAR:
            return {};
        case AjaxAction.CHECK_USER_TOTAL:
            return action.data;
        default:
            return state;
    }
}
const expand = (state = {}, action)=>{
    switch (action.type) {
        case AjaxAction.CHECK_CURRENT_USER_CLEAR:
            return {};
        case AjaxAction.CHECK_USER_EXPAND:
            return action.data;
        default:
            return state;
    }
}

const remit = (state = {}, action)=>{
    switch(action.type) {
        case AjaxAction.CHECK_CURRENT_USER_CLEAR:
            return {};
        case AjaxAction.CHECK_USER_REMIT:
            return action.data;
        default:
            return state;
    }
}

const income = (state = {}, action)=>{
    const {oper} = action;
    switch (action.type) {
        case AjaxAction.CHECK_CURRENT_USER_CLEAR:
            return {};
        case AjaxAction.CHECK_USER_INCOME:
            return {
                ...state,
                [oper]: action.data,
            }
        default:
            return state;
    }
}

const currentCheckUser = combineReducers({
    total,
    expand,
    remit,
    income,
})


// const currentCheckList = (state = [], action)=>{
//     switch (action.type) {
//         case AjaxAction.CHECK_DETAIL_ALL:
//             return action.data;
//         default:
//             return state;
//     }
// }

export default {
    currentCheckUser,
    // currentCheckList,
}



// WEBPACK FOOTER //
// ./src/reducers/checkingReducer.js